// extracted by mini-css-extract-plugin
export default {"Section":"Intro_Section__6tlMa","Content":"Intro_Content__Flhxt","Img":"Intro_Img__OrtRe","Header":"Intro_Header__cs6fP","Text":"Intro_Text__XrycN","Button":"Intro_Button__oTKHf"};